
import { defineComponent } from 'vue';
import ArrowDownIcon from '@/components/ui-elements/icons/ArrowDownIcon.vue';
import ArrowUpIcon from '@/components/ui-elements/icons/ArrowUpIcon.vue';
import Card from '@/components/ui-elements/card/Card.vue';

export default defineComponent({
	components: {
		ArrowDownIcon,
		ArrowUpIcon,
		Card,
	},
	props: {
		amount: {
			required: true,
			type: String,
		},
		percentage: {
			default: null,
			type: String,
		},
		text: {
			default: null,
			type: String,
		},
		title: {
			required: true,
			type: String,
		},
	},
});
